<app-layout-container>
  <app-bloghero [pageTitle]="hero.pageTitle"
                [title]="hero.title"
                [quote]="hero.quote"
                [text]="hero.text"
                [author]="hero.author"
                [role]="hero.role"
                [date]="hero.date"
                [imageSrc]="hero.imageSrc"
                [videoSrc]="hero.videoSrc"
                [imageAlt]="hero.imageAlt"
                [posterCaption]="hero.posterCaption"
                [readMoreLabel]="hero.readMoreLabel"
                [readMoreLink]="hero.readMoreLink"
                [contactLabel]="hero.contactLabel"
                [contactLink]="hero.contactLink"
                [qaLabel]="hero.qaLabel"
                [qaLink]="hero.qaLink">
  </app-bloghero>
</app-layout-container>

<app-layout-container>
  <section class="testimonials-grid-section">
    <div class="testimonials-grid">
      @for (item of testimonials; track item.slug) {
      @if (item.slug) {
      <a class="testimonial-card-link" [routerLink]="['/testimonial', item.slug]">
        <app-testimonial-card [imageSrc]="item.imageSrc"
                              [imageAlt]="item.imageAlt"
                              [title]="item.title"
                              [quote]="item.quote"
                              [name]="item.name"
                              [role]="item.role">
        </app-testimonial-card>
      </a>
      } @else {
      <app-testimonial-card [imageSrc]="item.imageSrc"
                            [imageAlt]="item.imageAlt"
                            [title]="item.title"
                            [quote]="item.quote"
                            [name]="item.name"
                            [role]="item.role">
      </app-testimonial-card>
      }
      }
    </div>
  </section>
</app-layout-container>

<section class="testimonials-band">
  <app-layout-container>
    <div class="testimonials-band__inner">
      <div>
        <app-section-heading [animateTitle]="true"
                             animateTitleTrigger="in-view"
                             eyebrow="Built to feel polished"
                             title="Professional from the first conversation through final delivery"
                             text="Whether the goal is a team experience, onboarding support, or event coordination, the goal is to make the process clear and client-friendly.">
        </app-section-heading>
      </div>

      <div class="testimonials-band__panel">
        <p class="testimonials-band__quote">
          “A strong experience is not only about the event itself — it is also about how smooth the process feels before it begins.”
        </p>
      </div>
    </div>
  </app-layout-container>
</section>

<app-layout-container>
  <section class="testimonials-cta">
    <div class="testimonials-cta__panel">
      <div>
        <app-section-heading [animateTitle]="true"
                             animateTitleTrigger="in-view"
                             eyebrow="Next step"
                             title="Ready to plan your own team experience?"
                             text="Tell us what you’re planning and we’ll help you shape the right next step.">
        </app-section-heading>
      </div>

      <div class="testimonials-cta__actions">
        <a class="button button--primary" routerLink="/contact-us">Contact Us</a>
        <a class="button button--secondary" routerLink="/services">Explore Services</a>
      </div>
    </div>
  </section>
</app-layout-container>
